export var dttmenu = {
  Admin: {
    modules: {
      Home: {
        name: 'Home',
        uri: '/',
        permissions: []
      },
      Operator: {
        availability: {
          name: 'Availability',
          uri: '/availability',
          permissions: []
        },
        bookings: {
          name: 'Bookings',
          uri: '/bookings',
          permissions: []
        },
        rates: {
          name: 'Rates',
          uri: '/rates',
          permissions: []
        },
        rateplans: {
          name: 'Rate Plans',
          uri: '/rateplans',
          permissions: []
        },
      },
      Hotel: {
        hotels: {
          name: 'Hotels',
          uri: '/hotels',
          permissions: []
        },
        inventory: {
          name: 'Inventory',
          uri: '/inventory',
          permissions: []
        },
        roomtypes: {
          name: 'Room Types',
          uri: '/roomtypes',
          permissions: []
        },
        childspolicies: {
          name: 'Child Policies',
          permissions: [],
          uri: '/childspolicies'
        },
      },
      Admin: {
        integration:{
          name:'Integration',
          uri:'/integration',
          permissions:[]
        },
        logs:{
          name:'Logs',
          uri:'/logs',
          permissions:[]
        },
        logstock:{
          name:'Logstock',
          uri:'/logstock',
          permissions:[]
        },
        emails:{
          name:'Emails',
          uri:'/emails',
          permissions:[]
        },
        users:{
          name:'Users',
          uri:'/users',
          permissions:[]
        }
      }
    }
  },
  Manager: {
    modules: {
      availability: {
        name: 'Availability',
        uri: '/availability',
        permissions: []
      },
      bookings: {
        name: 'Bookings',
        uri: '/bookings',
        permissions: []
      },
      rates: {
        name: 'Rates',
        uri: '/rates',
        permissions: []
      },
      rateplans: {
        name: 'Rate Plans',
        uri: '/rateplans',
        permissions: []
      },
      users:{
        name:'Users',
        uri:'/users',
        permissions:[]
      },
      clients:{
        name:'Clients',
        uri:'/clients',
        permissions:[]
        },
      Hotel: {
        hotels: {
          name: 'Hotels',
          uri: '/hotels/status',
          permissions: []
        },
        childspolicies: {
          name: 'Child Policies',
          permissions: [],
          uri: '/childspolicies'
        },
        inventory: {
          name: 'Inventory',
          uri: '/inventory',
          permissions: []
        },
        roomtypes: {
          name: 'Room Types',
          uri: '/roomtypes',
          permissions: []
        },
      }
    }
  },
  Hotel: {
    modules: {
      home: {
        name: 'Home',
        uri: '/',
        permissions: []
      },
      inventory: {
        name: 'Inventory',
        uri: '/inventory',
        permissions: []
      },
      hotels: {
        name: 'Hotels',
        uri: '/hotels',
        permissions: []
      },
      rates: {
        name: 'Rates',
        uri: '/rates',
        permissions: []
      },
      rateplans: {
        name: 'Rate Plans',
        uri: '/rateplans',
        permissions: []
      },
      bookings: {
        name: 'Bookings',
        uri: '/bookings',
        permissions: []
      },
      roomtypes: {
        name: 'Room Types',
        uri: '/roomtypes',
        permissions: []
      },
      childspolicies: {
        name: 'Child Policies',
        permissions: [],
        uri: '/childspolicies'
      }
    }
  },
  Saler: {
    modules: {
      availability: {
        name: 'Availability',
        uri: '/availability',
        permissions: []
      },
      bookings: {
        name: 'Bookings',
        uri: '/bookings',
        permissions: []
      },
      inventory: {
        name: 'Inventory',
        uri: '/inventory',
        permissions: []
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/routes/magicnav.js